import { useCallback } from 'react'
import { useExperimentApi } from '../../store/api/hooks/experimentApiHook'
import { getColumnDef, normalizeRowValues } from '../functions'
import toast from 'react-hot-toast'
import { ErrorResponse } from '../../store/api/apiTypes'

type AdditionalTableType = 'AdditionalDesign' | 'AdditionalMeasurement'

type ComponentFunctions = {
    onAdditionalCsvUploaded: (tableType: AdditionalTableType, literal: string, setAdditionalcolumnDefs: (columnDefs: any) => void, setAdditionalRowData: (rowData: any[]) => void) => void
    doAnotherThing: (value: string) => void
}

export function useComponentFunctions(): ComponentFunctions {
    const experimentApi = useExperimentApi()
    const onAdditionalCsvUploaded = useCallback((tableType: AdditionalTableType, literal: string, setAdditionalcolumnDefs: (columnDefs: any) => void, setAdditionalRowData: (rowData: any[]) => void) => {
        const payload = {
            table_type: tableType,
        }

        experimentApi.getFilterPreviwData(
            {
                literal,
                page: 1,
                per_page: 40,
                ...payload,
            },
            (data: any) => {
                const rows: any[] = (data?.data?.result ?? []).filter((row: any) => row && typeof row === 'object').map(normalizeRowValues)

                if (rows.length > 0) {
                    const columnDefs: any = getColumnDef(rows)
                    setAdditionalcolumnDefs(columnDefs)
                    setAdditionalRowData(rows)
                } else {
                    setAdditionalRowData([])
                    toast.error('No results found for the specified query. Please adjust your conditions.')
                }
            },
            (error: ErrorResponse<[]>) => {
                setAdditionalRowData([])
            },
        )
    }, [])

    const doAnotherThing = useCallback((value: string) => {
        // Implement your logic here
        console.log(`Doing another thing with ${value}`)
    }, [])

    return {
        onAdditionalCsvUploaded,
        doAnotherThing,
    }
}
